import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button/Button';
import { PlusIcon } from '@utils/icons';
import styles from './emptyBoard.module.css';

export interface IEmptyBoardProps {
  /** Absent when the viewer may not create issues — the call to action is not rendered. */
  onCreateIssue?: () => void;
}

/** Guided empty state for a site with no activities and no issues — the
 *  state-derived replacement for trusstor's seeded "initial issue" (spec:
 *  docs/specs/2026-07-23-issues-empty-state-design.md). */
export function EmptyBoard({ onCreateIssue }: IEmptyBoardProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <div className={styles.icon} aria-hidden="true">
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        >
          <rect x="3" y="5" width="18" height="16" rx="2.5" />
          <path d="M3 10h18M8 3v4M16 3v4" />
        </svg>
      </div>
      <p className={styles.title}>{t('activities.emptyState.title')}</p>
      {onCreateIssue && (
        <Button variant="primary" size="sm" className={styles.cta} onClick={onCreateIssue}>
          <PlusIcon size={14} />
          {t('activities.emptyState.cta')}
        </Button>
      )}
    </div>
  );
}
